"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _delinquencyUtils = require("../../util/delinquencyUtils");

require("./DelinquencyAlert.scss");

var _br, _strong;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DelinquencyAlert = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DelinquencyAlert, _React$Component);

  var _super = _createSuper(DelinquencyAlert);

  function DelinquencyAlert() {
    (0, _classCallCheck2["default"])(this, DelinquencyAlert);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DelinquencyAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          userId = _this$props.userId,
          spId = _this$props.spId,
          delinquency = _this$props.delinquency;

      _angieslistAppPlatform.tracker.track('Item Displayed', {
        serviceProviderId: spId,
        activityLocation: 'SP : Advertising Payment Info',
        description: 'Delinquent Banner',
        numDaysDelinquent: (0, _delinquencyUtils.totalDaysDelinquent)(delinquency.delinquentSince),
        userId: userId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          delinquency = _this$props2.delinquency,
          spId = _this$props2.spId;
      var showPaymentLink = window.location.pathname !== _urlCatalog["default"].office.paymentMethod;
      var daysUntilLockout = delinquency.daysUntilLockout; // A sp is delinquent starting the day after payment is due

      var phoneText = _urlCatalog["default"].global.spCarePhoneText();

      var phoneLink = _urlCatalog["default"].global.spCarePhone();

      var alertIcon = 'icon-info-circled';
      var alertMessage = "Your payment is overdue. You have ".concat(daysUntilLockout, "\n    ").concat(daysUntilLockout > 1 ? 'days' : 'day', " before access to your business center is restricted.");

      if (daysUntilLockout < 1) {
        alertMessage = 'Access to your business center has been restricted due to an unpaid balance.';
        alertIcon = 'icon-attention';
      }

      return /*#__PURE__*/React.createElement(_Alert["default"], {
        bsStyle: "info",
        className: "alert-with-icon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-2x ".concat(alertIcon)
      }), /*#__PURE__*/React.createElement(_Grid["default"], null, /*#__PURE__*/React.createElement(_Row["default"], null, /*#__PURE__*/React.createElement(_Col["default"], {
        xs: 12,
        lg: showPaymentLink ? 9 : 12
      }, /*#__PURE__*/React.createElement("span", null, ' ', /*#__PURE__*/React.createElement("strong", null, alertMessage), _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Update your payment information and we will process the payment within 24 hours. Have questions? Call us at", ' ', /*#__PURE__*/React.createElement("a", {
        id: "advertising-payment-info-telephone",
        href: phoneLink,
        style: {
          whiteSpace: 'nowrap'
        }
      }, ' ', phoneText), ".")), showPaymentLink ? /*#__PURE__*/React.createElement(_Col["default"], {
        xs: 12,
        lg: 3
      }, /*#__PURE__*/React.createElement("span", {
        className: "update-payment-span"
      }, /*#__PURE__*/React.createElement("a", {
        id: "delinquency-alert--payment-preferences-".concat(spId),
        href: _urlCatalog["default"].office.paymentMethod(spId),
        className: "text-secondary btn-link btn-ghost"
      }, _strong || (_strong = /*#__PURE__*/React.createElement("strong", null, "Update Payment Info"))))) : null)));
    }
  }]);
  return DelinquencyAlert;
}(React.Component);

var _default = (0, _compose["default"])(_pure["default"])(DelinquencyAlert);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/DelinquencyAlert.js
// module id = 1286
// module chunks = 25